<template>
    <component :is="iconComponent" :key="icon" :name="icon" />
</template>
<script setup>
import { computed, defineAsyncComponent, defineProps } from 'vue';

const props = defineProps({
    icon: String
});

const iconComponent = computed(() =>
    defineAsyncComponent(() =>
        import(`../components-new/svg/${props.icon}.vue`)
    )
);
</script>
